import { z } from 'zod';

const guestSchema = z.object({
  title: z.string().optional().nullable(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  gender: z.string().optional(),
  externalSpaId: z.union([z.string(), z.number()]).optional().nullable(),
  id: z.union([z.string(), z.number()]).optional(),
});

export const spaClassFormSchema = z
  .object({
    guests: z.array(guestSchema),
  })
  .superRefine((data, ctx) => {
    if (!data.guests || data.guests.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'required',
        path: ['guests'],
      });
      return;
    }

    data.guests.forEach((guest, index) => {
      if (!guest.title?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'required',
          path: ['guests', index, 'title'],
        });
      }
      if (!guest.firstName?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'required',
          path: ['guests', index, 'firstName'],
        });
      }
      if (!guest.lastName?.trim()) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'required',
          path: ['guests', index, 'lastName'],
        });
      }
    });
  });

export type SpaClassFormValues = z.infer<typeof spaClassFormSchema>;
